import React, { useState, useEffect, useRef } from 'react';
import './room1.css';
import './room2.css';
import Settings from '../components/common/settings';
import Lost from '../components/common/lost';
import { useNavigate } from 'react-router-dom';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';

const TOTAL_TIME = 10 * 60;
const ROOM_KEY = 'room2_time';

const Room2 = () => {
  const navigate = useNavigate();

  // this is the entry page for Room 2, so we always start a fresh timer here
  const [timeLeft, setTimeLeft] = useState(() => {
    localStorage.setItem(ROOM_KEY, Date.now());
    return TOTAL_TIME;
  });

  const [openSettings, setOpenSettings] = useState(false);
  const [showTapeIntro, setShowTapeIntro] = useState(true);
  const [showLosePopup, setShowLosePopup] = useState(false);

  const [inventory, setInventory] = useState([]);
  const [collectedGlass, setCollectedGlass] = useState(false);
  const [showNextBtn, setShowNextBtn] = useState(false);

  const lockedAudio = useRef(null);
  const settingsAudio = useRef(null);

  useEffect(() => {
    lockedAudio.current = new Audio(lockedSound);
    settingsAudio.current = new Audio(settingsSound);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const saved = localStorage.getItem(ROOM_KEY);
      if (!saved) return;

      const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
      const remaining = Math.max(TOTAL_TIME - elapsed, 0);

      setTimeLeft(remaining);

      if (remaining === 0) {
        setShowLosePopup(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowTapeIntro(false);
    }, 3200);

    return () => clearTimeout(timeout);
  }, []);

  const collectMagnifyingGlass = () => {
    if (collectedGlass) return;
    setCollectedGlass(true);
    setInventory((prev) => [...prev, 'magnifying_glass']);
    setShowNextBtn(true);
  };

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  return (
    <section className="room2div">
      <div className="inventorybar">
        {inventory.includes('magnifying_glass') && (
          <div className="inventory-item magnify-icon" />
        )}
      </div>
      {showTapeIntro && (
        <div className="tapeintro">
          <div className="cautiontape tape-a" />
          <div className="cautiontape tape-b" />
          <div className="cautiontape tape-c" />
        </div>
      )}
      <div className="room1nav">
        <div />

        <div className="roomtimer">
          <span className="timerlabel">TIME REMAINING</span>

          <div className="timerdiv">
            <span className={`timerdigits ${isWarning ? 'timerwarning' : ''}`}>
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning ? '#ff4444' : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div className="settings" onClick={openSettingsMenu} />
      </div>

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />
      {!collectedGlass && (
        <div
          className="maginfyglass"
          onClick={collectMagnifyingGlass}
          style={{ cursor: 'pointer' }}
        />
      )}

      {showNextBtn && (
        <button
          className="nextbt"
          onClick={() => navigate('/pipes')}
        >
          NEXT
        </button>
      )}

      <Lost
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem(ROOM_KEY);
          window.location.reload();
        }}
      />

    </section>
  );
};

export default Room2;